
import React from 'react'
import { Box } from '@mui/material'
import GiacenzeForm from './GiacenzeForm'
import { useSelector } from 'react-redux'

export const StabilimentiGiacenzeSlider = ({ cantine, setCantine }) => {
    const singleData = useSelector((state) => state.giacenze?.singleGiacenza[0])
    console.log(singleData,"SINGLEData")

    return (
        <Box className='customDrawer_container'>
            <Box className='boxContainer__head'>
                <h2 className="boxContainer__title">Registra una Giacenze</h2>
            </Box>
            <GiacenzeForm cantine={cantine} setCantine={setCantine} singleData={singleData}/>
        </Box>
    )
}
